<template>
    <div id="content">
        <div class="header">
            <h3>カラー・サイズ別売上</h3>
            <a class="btn close" @click="$emit('modalClosed')"></a>
        </div>

        <div class="pdt">
            <div v-if="productLists.length > 0">
                <div class="wrap" v-for="product in productLists" :key="product.id">
                    <h1>
                        ●【{{ product.id }}<Icon v-if="product.is_set_product" title="セット商品">
                            dice-multiple-outline</Icon>】{{ product.name }}
                    </h1>
                    <div v-if="product.is_set_product == 0">
                        <table id="roasTable">
                            <thead>
                                <tr>
                                    <th @click="setOrder('id', product.id)">
                                        商品ID
                                        <span v-if="isOrderAsc === 'id_asc' && isOrderTargetId === product.id">▲</span>
                                        <span v-if="isOrderAsc === 'id_desc' && isOrderTargetId === product.id">▼</span>
                                    </th>
                                    <th @click="setOrder('color', product.id)">
                                        カラー
                                        <span
                                            v-if="isOrderAsc === 'color_asc' && isOrderTargetId === product.id">▲</span>
                                        <span
                                            v-if="isOrderAsc === 'color_desc' && isOrderTargetId === product.id">▼</span>
                                    </th>
                                    <th @click="setOrder('size', product.id)">
                                        サイズ
                                        <span
                                            v-if="isOrderAsc === 'size_asc' && isOrderTargetId === product.id">▲</span>
                                        <span
                                            v-if="isOrderAsc === 'size_desc' && isOrderTargetId === product.id">▼</span>
                                    </th>
                                    <th @click="setOrder('sales', product.id)">
                                        売上(税抜)
                                        <span
                                            v-if="isOrderAsc === 'sales_asc' && isOrderTargetId === product.id">▲</span>
                                        <span
                                            v-if="isOrderAsc === 'sales_desc' && isOrderTargetId === product.id">▼</span>
                                    </th>
                                    <th @click="setOrder('units', product.id)">
                                        数量
                                        <span
                                            v-if="isOrderAsc === 'units_asc' && isOrderTargetId === product.id">▲</span>
                                        <span
                                            v-if="isOrderAsc === 'units_desc' && isOrderTargetId === product.id">▼</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(detail, productId) in dispReports(product.details, product.id)"
                                    :key="productId">
                                    <td>{{ detail.product_id }}</td>
                                    <td>{{ detail.color_name }}</td>
                                    <td>{{ detail.size_name }}</td>
                                    <td class="ta-r">{{ detail.amount | priceLocaleString }}</td>
                                    <td class="ta-r">{{ detail.units }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>
                        <div v-for="(detail, setId) in product.details" :key="setId">
                            <h2>
                                ○【{{ setId }}】
                            </h2>
                            <div v-for="(de, productId) in detail" :key="productId">
                                <div v-if="productId != 'amount' && productId != 'units'">
                                    <h2>
                                        &emsp;【{{ de.id }}】{{ de.name }}
                                    </h2>
                                    <table id="roasTable2">
                                        <thead>
                                            <tr>
                                                <th @click="setOrderSet('id')">
                                                    商品ID
                                                    <span v-if="isOrderAscSet === 'id_asc'">▲</span>
                                                    <span v-if="isOrderAscSet === 'id_desc'">▼</span>
                                                </th>
                                                <th @click="setOrderSet('color')">
                                                    カラー
                                                    <span v-if="isOrderAscSet === 'color_asc'">▲</span>
                                                    <span v-if="isOrderAscSet === 'color_desc'">▼</span>
                                                </th>
                                                <th @click="setOrderSet('size')">
                                                    サイズ
                                                    <span v-if="isOrderAscSet === 'size_asc'">▲</span>
                                                    <span v-if="isOrderAscSet === 'size_desc'">▼</span>
                                                </th>
                                                <th @click="setOrderSet('sales')">
                                                    売上(税抜)
                                                    <span v-if="isOrderAscSet === 'sales_asc'">▲</span>
                                                    <span v-if="isOrderAscSet === 'sales_desc'">▼</span>
                                                </th>
                                                <th @click="setOrderSet('units')">
                                                    数量
                                                    <span v-if="isOrderAscSet === 'units_asc'">▲</span>
                                                    <span v-if="isOrderAscSet === 'units_desc'">▼</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(d, pId) in dispReportsSet(de.details)" :key="pId">
                                                <td>{{ d.product_id }}</td>
                                                <td>{{ d.color_name }}</td>
                                                <td>{{ d.size_name }}</td>
                                                <td class="ta-r">{{ d.amount | priceLocaleString }}</td>
                                                <td class="ta-r">{{ d.units }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <h1>売上実績がありません</h1>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        type: String,
        productId: Number,
        totallingTargetId: Number,
        dateBase: Boolean,
        startDate: String,
        endDate: Object,
        serviceId: Number,
    },
    data() {
        return {
            productLists: [],
            isOrderAsc: "sales_desc",
            isOrderAscSet: "sales_desc",
            isOrderTargetId: 0,
            isOrderAscArray: {},
        }
    },
    mounted: function () {
        this.getRoas();
    },
    methods: {
        //カラー・サイズ別の売上取得
        getRoas: function () {
            this.$store.dispatch("loading", true);

            const yesterday = this.$dayjs().startOf('date').subtract(1, 'days').format('YYYY-MM-DD');
            const searchEndedAt = (this.endDate < yesterday) ? this.endDate : yesterday;

            const searchStartedDate = this.startDate + ' 00:00:00';
            const searchEndedDate = searchEndedAt + ' 23:59:59';

            let url = '';
            let target = '';

            if (this.type === "single") {
                if (this.productId === -1) {
                    //全商品
                    url = "/api/colorSize/all";
                }
                else {
                    //単一商品
                    url = "/api/colorSize/single";
                }
                target = this.productId;
            }
            else {
                //グループ商品
                url = "/api/colorSize/totalling";
                target = this.totallingTargetId;
            }

            this.axios.get(url, {
                params: {
                    dateBase: this.dateBase,
                    startDate: searchStartedDate,
                    endDate: searchEndedDate,
                    serviceId: this.serviceId,
                    targetId: target,
                }
            })
                .then((res) => {
                    this.productLists = _.map(res.data, product => {
                        return product;
                    });
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        //ソート
        setOrder(target, id) {
            this.isOrderTargetId = id;

            //商品ID
            if (target == "id") {
                if (this.isOrderAsc == "id_asc") {
                    this.isOrderAsc = "id_desc"
                }
                else {
                    this.isOrderAsc = "id_asc"
                }
            }

            //カラー
            else if (target == "color") {
                if (this.isOrderAsc == "color_asc") {
                    this.isOrderAsc = "color_desc"
                }
                else {
                    this.isOrderAsc = "color_asc"
                }
            }

            //サイズ
            else if (target == "size") {
                if (this.isOrderAsc == "size_asc") {
                    this.isOrderAsc = "size_desc"
                }
                else {
                    this.isOrderAsc = "size_asc"
                }
            }

            //売上
            else if (target == "sales") {
                if (this.isOrderAsc == "sales_asc") {
                    this.isOrderAsc = "sales_desc"
                }
                else {
                    this.isOrderAsc = "sales_asc"
                }
            }

            //数量
            else if (target == "units") {
                if (this.isOrderAsc == "units_asc") {
                    this.isOrderAsc = "units_desc"
                }
                else {
                    this.isOrderAsc = "units_asc"
                }
            }
        },
        dispReports(targetList, id) {
            let reportsArray = Object.values(targetList);

            if (this.isOrderAscArray[id] == undefined) {
                this.isOrderAscArray[id] = "sales_desc";
            }


            if (this.isOrderTargetId == id) {
                this.isOrderAscArray[id] = this.isOrderAsc;
            }


            //商品ID
            if (this.isOrderAscArray[id] == "id_desc") {
                return reportsArray.sort((a, b) => b.product_id_int - a.product_id_int);
            }
            else if (this.isOrderAscArray[id] == "id_asc") {
                return reportsArray.sort((a, b) => a.product_id_int - b.product_id_int);
            }

            //カラー
            else if (this.isOrderAscArray[id] == "color_desc") {
                return reportsArray.sort((a, b) => b.color_name.localeCompare(a.color_name, 'ja', { sensitivity: 'base' }));
            }
            else if (this.isOrderAscArray[id] == "color_asc") {
                return reportsArray.sort((a, b) => a.color_name.localeCompare(b.color_name, 'ja', { sensitivity: 'base' }));
            }

            //サイズ
            else if (this.isOrderAscArray[id] == "size_desc") {
                return reportsArray.sort((a, b) => b.size_name_int - a.size_name_int);
            }
            else if (this.isOrderAscArray[id] == "size_asc") {
                return reportsArray.sort((a, b) => a.size_name_int - b.size_name_int);
            }

            //売上
            else if (this.isOrderAscArray[id] == "sales_desc") {
                return reportsArray.sort((a, b) => b.amount - a.amount);
            }
            else if (this.isOrderAscArray[id] == "sales_asc") {
                return reportsArray.sort((a, b) => a.amount - b.amount);
            }

            //数量
            else if (this.isOrderAscArray[id] == "units_desc") {
                return reportsArray.sort((a, b) => b.units - a.units);
            }
            else if (this.isOrderAscArray[id] == "units_asc") {
                return reportsArray.sort((a, b) => a.units - b.units);
            }

            //その他
            else {
                return targetList;
            }
        },
        //セット商品ソート
        setOrderSet(target) {
            //商品ID
            if (target == "id") {
                if (this.isOrderAscSet == "id_asc") {
                    this.isOrderAscSet = "id_desc"
                }
                else {
                    this.isOrderAscSet = "id_asc"
                }
            }

            //カラー
            if (target == "color") {
                if (this.isOrderAscSet == "color_asc") {
                    this.isOrderAscSet = "color_desc"
                }
                else {
                    this.isOrderAscSet = "color_asc"
                }
            }

            //サイズ
            if (target == "size") {
                if (this.isOrderAscSet == "size_asc") {
                    this.isOrderAscSet = "size_desc"
                }
                else {
                    this.isOrderAscSet = "size_asc"
                }
            }

            //売上
            else if (target == "sales") {
                if (this.isOrderAscSet == "sales_asc") {
                    this.isOrderAscSet = "sales_desc"
                }
                else {
                    this.isOrderAscSet = "sales_asc"
                }
            }

            //数量
            if (target == "units") {
                if (this.isOrderAscSet == "units_asc") {
                    this.isOrderAscSet = "units_desc"
                }
                else {
                    this.isOrderAscSet = "units_asc"
                }
            }
        },
        dispReportsSet(targetList) {
            let reportsArray = Object.values(targetList);

            //商品ID
            if (this.isOrderAscSet == "id_desc") {
                return reportsArray.sort((a, b) => b.product_id_int - a.product_id_int);
            }
            else if (this.isOrderAscSet == "id_asc") {
                return reportsArray.sort((a, b) => a.product_id_int - b.product_id_int);
            }

            //カラー
            if (this.isOrderAscSet == "color_desc") {
                return reportsArray.sort((a, b) => b.color_name.localeCompare(a.color_name, 'ja', { sensitivity: 'base' }));
            }
            else if (this.isOrderAscSet == "color_asc") {
                return reportsArray.sort((a, b) => a.color_name.localeCompare(b.color_name, 'ja', { sensitivity: 'base' }));
            }

            //サイズ
            if (this.isOrderAscSet == "size_desc") {
                return reportsArray.sort((a, b) => b.size_name_int - a.size_name_int);
            }
            else if (this.isOrderAscSet == "size_asc") {
                return reportsArray.sort((a, b) => a.size_name_int - b.size_name_int);
            }

            //売上
            else if (this.isOrderAscSet == "sales_desc") {
                return reportsArray.sort((a, b) => b.amount - a.amount);
            }
            else if (this.isOrderAscSet == "sales_asc") {
                return reportsArray.sort((a, b) => a.amount - b.amount);
            }

            //数量
            else if (this.isOrderAscSet == "units_desc") {
                return reportsArray.sort((a, b) => b.units - a.units);
            }
            else if (this.isOrderAscSet == "units_asc") {
                return reportsArray.sort((a, b) => a.units - b.units);
            }

            //その他
            else {
                return targetList;
            }

        },
    },
}
</script>

<style scoped lang="sass">
#content
    padding: 16px 32px
    height: 100%
    width: 100%
    color: $grayColor
    .header
        padding: 5px
        height: 50px
        margin-bottom: 5px
        h3
            display: block
            float: left
            font-size: 20px
        .btn.close
            float: right
    .dispSettingItem
        margin-right: 10px;
    .dispSettingItemSelect
        width: 50%
        max-width: 240px
    .pdt
        padding-bottom: 20px;
        width: 100%
        height: 90%;
        overflow-y: scroll;
        &::-webkit-scrollbar
            width: 4px
            border-radius: 2px
            background-color: #c0c0c0
        &::-webkit-scrollbar-thumb
            border-radius: 2px
            background-color: $mainColor
        .wrap:not(:first-child)
            margin-top: 30px;
        h1
            font-size: 18px;
        h2
            margin-top: 10px;
            font-size: 15px;
    #roasTable
        width: 99%;
        font-size: 15px;
        margin: 0 auto;
    thead
        th
            background-color: $mainColor
            border: 1px solid $mainColor
            color: #fff
            padding: 10px 5px
            width: (100% / 5);
            cursor: pointer
    tbody
        tr
            background: $whiteColor
            border: 1px solid $mainColor
        td
            border: 1px solid $mainColor
            padding: 10px 5px
            line-height: 20px
    #roasTable2
        width: 95%;
        font-size: 15px;
        margin: 0 auto;
    thead
        th
            background-color: $mainColor
            border: 1px solid $mainColor
            color: #fff
            padding: 10px 5px
            width: (100% / 5);
    tbody
        tr
            background: $whiteColor
            border: 1px solid $mainColor
        td
            border: 1px solid $mainColor
            padding: 10px 5px
            line-height: 20px
    .ta-c
        text-align: center
        vertical-align: middle
    .ta-r
        text-align: right

@include sp()
    #content
        .pdt
            h1
                font-size: 14px;
            h2
                font-size: 12px;
        #roasTable
            font-size: 12px;
        #roasTable2
            font-size: 12px;
</style>